<template lang="pug">
	modal
		.card.text-left
			.card-header
				span.fa.fa-calendar.mr-2
				| Ediciones de EGM
				button.close(type='button' aria-label='Close' @click='cerrar')
					span(aria-hidden='true') &times;
			.card-body.bg-light
				h4
					b Dimensión de los datos
				.row
					.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6.mb-2
						.form-group
							label(for='')
								b Selecciona edición
							datepicker(
								minimum-view='month'
								:language='$dateLang'
								v-model='edicion.fecha'
								:bootstrap-styling='true'
								@closed='setEdicion'
								format='MMMM, yyyy'
								:disabled-dates="ignoraFechas"
							)
					.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6.mb-2(v-if='edicion.fecha')
						.form-group
							label(for='')
								b Selecciona la emisora
							.input-group(v-if='!edicion.emisora_ID')
								input-query(url='gestion-egm/php/api/query-emisoras.php' :realtime='true' input-class='form-control' @selected='seleccionaEmisora($event)')
								.input-group-append
									button.btn.btn-primary(@click="idEmisora = 'nueva'")
										span.fa.fa-plus.mr-2
										| Nueva
							.input-group(v-else)
								input.form-control(disabled="true", :value="edicion.emisoraInfo.nombre")
								.input-group-append
									button.btn.btn-danger(@click="edicion.emisora_ID = null")
										span.fa.fa-trash
			.card-body.bg-light(v-if="edicion.emisora_ID")
				h4
					b Audiencia total (en miles)
				input.form-control(v-model="edicion.oyentes")
			.card-body(v-if="edicion.emisora_ID")
				h4
					b Audiencia por horas (en miles)
				.row
					.col-xs-6.col-sm-4.col-md-4.col-lg-4.col-xl-4.p-1(v-for="h in edicion.horas", :key="h.hora")
						.input-group
							.input-group-prepend
								.input-group-text(style="width: 70px;")
									| {{h.hora}}:00
							input.form-control.form-control-sm(v-model="edicion.horas[h.hora].oyentes")
			.card-footer
				button.btn.btn-primary(@click="guardar")
					span.fa.fa-save.mr-2
					| Guardar
		editor-emisora(v-if="idEmisora", :id-emisora="idEmisora", @cerrar="idEmisora = null")
</template>

<script>
import axios from 'axios'
import EditorEmisora from './nueva-emisora'

export default {
	components: {
		'editor-emisora': EditorEmisora
	},
	data () {
		return {
			idEmisora: null,
			edicion: {
				fecha: null,
				fechaUnix: null,
				emisora_ID: null,
				emisoraInfo: null,
				oyentes: null,
				horas: []
			},
			ignoraFechas: {
				customPredictor: date => {
					if (!date.getMonth().toString().match(/^(3|6|11)$/)) {
						return true
					}

					return false
				}
			}
		}
	},

	methods: {
		setEdicion (ev) {
			this.edicion.ano = this.edicion.fecha.getFullYear()
			this.edicion.mes = this.edicion.fecha.getMonth() + 1
			if (this.edicion.emisora_ID) {
				this.getEdicion()
			}
		},

		seleccionaEmisora (ev) {
			this.edicion.emisora_ID = ev.datos.ID_emisora
			this.edicion.emisoraInfo = ev.datos
			this.getEdicion()
		},

		getEdicion () {
			// Ahora obtenemos las cifras de audiencia si existen
			const datos = {
				fechaUnix: Math.floor(this.edicion.fecha.getTime() / 1000),
				emisora_ID: this.edicion.emisora_ID
			}

			axios.post('/gestion-egm/php/api/get-edicion.php', datos)
				.then(res => {
					this.edicion = res.data.edicion
					this.edicion.fecha = new Date(this.edicion.fechaUnix * 1000)
					this.$forceUpdate()
				})
				.catch(() => {
					this.generaHoras()
				})
		},

		generaHoras () {
			this.edicion.horas = []
			for (let i = 0; i < 24; i++) {
				this.edicion.horas.push({
					hora: i,
					oyentes: 0
				})
			}
		},

		guardar () {
			this.edicion.fechaUnix = Math.floor(this.edicion.fecha.getTime() / 1000)
			axios.post('/gestion-egm/php/api/set-edicion.php', this.edicion)
				.then(res => {
					this.edicion = res.data.edicion
					this.edicion.fecha = new Date(this.edicion.fechaUnix * 1000)
					this.$store.commit('toast/success', {
						titulo: 'Guardado',
						mensaje: 'Se han guardado los datos'
					})
				})
				.catch(this.$responseError)
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-egm/vue/components/gestion-ediciones.vue